import {
  CSS3,
  Java,
  Git,
  Express,
  HTML5,
  Javascript,
  Mongodb,
  Nextjs,
  Nextjs2,
  Nodejs,
  Python,
  Reactjs,
  InfiniteTube,
  NoteHere,
  RandomQuote,
  DarkMode,
  Weather,
  ToDoApp,
 
} from "./assets";

export const projectStats = [
  {
    name: "Total Projects",
    value: "15+",
  },
  {
    name: "Website Design",
    value: "10+",
  },

  {
    name: "Clients worldwide",
    value: "+2",
  },
];

export const tools = [
  {
    name: "MongoDB",
    icon: Mongodb,
  },
  {
    name: "Express",
    icon: Express,
  },
  {
    name: "React",
    icon: Reactjs,
  },
  {
    name: "NodeJs",
    icon: Nodejs,
  },
  {
    name: "NextJs",
    icon: Nextjs2,
  },
];

export const skills = [
  {
    name: "ReactJs",
    icon: Reactjs,
  },
  {
    name: "NodeJs",
    icon: Nodejs,
  },
  {
    name: "ExpressJs",
    icon: Express,
  },
  {
    name: "NextJs",
    icon: Nextjs,
  },
  {
    name: "MongoDB",
    icon: Mongodb,
  },
  {
    name: "CSS3",
    icon: CSS3,
  },
  {
    name: "HTML5",
    icon: HTML5,
  },
  {
    name: "JavaScript",
    icon: Javascript,
  },
  {
    name: "Git",
    icon: Git,
  },
  {
    name: "Java",
    icon: Java,
  },
  {
    name: "Python",
    icon: Python,
  },
];

export const projects = [
  {
    id: 1,
    title: "Ak@HUB ",
    cat: "React, Material Ui, Rapid API",
    url: "https://fancy-crumble-c9a1a6.netlify.app/",
    img: InfiniteTube,
  },
  {
    id: 2,
    title: "Dark Mode Toggle",
    cat: "React",
    url: "https://github.com/Ak6355/Dark-Mode",
    img: DarkMode,
  },
  {
    id: 3,
    title: "Random Quote Generator",
    cat: "React",
    url: "https://6558b6b0ddbcd063c72108cb--chimerical-rolypoly-da72a2.netlify.app/",
    img: RandomQuote,
  },
 

  {
    id: 4,
    title: "ToDo App",
    cat: "Node, React, Express, MongoDB",
    url: "https://github.com/Ak6355/TODOAPP",
    img: ToDoApp,
  },
  
  
  {
    id: 5,
    title: "Notes Making Website",
    cat: "Html, Css, Js",
    url: "https://github.com/Ak6355/NOTES-Add",
    img: NoteHere,
  },
 
  {
    id: 6,
    title: "Weather App",
    cat: "Html, Css, Js",
    url: "https://github.com/Ak6355/WeatherNow-",
    img: Weather,
  },
 
];

export const softskills = [
  "Time management",
  "Communication",
  "Empathy",
  "Teamwork",
  "Helpfulness",
  "Creativity",
  "Self-learning",
  "Accountability",
  "Problem solving",
  "Open-mindedness",
];
